import {
  AspectRatio,
  Box,
  Flex,
  FlexProps,
  Image,
  Stack,
  Text,
  useMediaQuery,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

type TextBannerProps = FlexProps & {
  text: string;
};

export const TextBanner: React.FC<TextBannerProps> = ({ text, ...rest }) => {

  return (
    <Flex backgroundColor={"#ffd1d2"} p={4} borderRadius={6} mb={12} {...rest}>
      <Text fontWeight={"bold"} color="#ee2127" textAlign={"left"}>{text}</Text>
    </Flex>
  );
};
